import { Flex } from '@chakra-ui/react';

export const TiptapMenubar = (props: any) => (
   <Flex
      bgColor="gray.50"
      borderWidth={1}
      borderRadius="md"
      position="sticky"
      px={2}
      py={1}
      top={0}
      zIndex={1}
      flexWrap="wrap"
      {...props}
   >
      {props.children}
   </Flex>
);
